import { jsx as _jsx } from "react/jsx-runtime";
import { ClipStatus } from "@air/api/types";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useMemo, useState } from "react";
import { AssetGalleryCardFailedTranscode } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardFailedTranscode";
import { AssetGalleryCardProcessing } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardProcessing";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
import { getRoundedImgixDimensions } from "~/utils/getRoundedImgixDimensions";
export const GalleryAssetThumbnailImage = /*#__PURE__*/ memo((param)=>{
    let { animatedSrc, className, description, ext, height, imgixParams, status, src, width } = param;
    const [isLoaded, setLoaded] = useState(false);
    const imgixDimensions = useMemo(()=>getRoundedImgixDimensions({
            width,
            height
        }), [
        height,
        width
    ]);
    if ([
        ClipStatus.failed,
        ClipStatus.nonTranscodable
    ].includes(status)) {
        return /*#__PURE__*/ _jsx(AssetGalleryCardFailedTranscode, {
            ext: ext
        });
    }
    // If there is no src, we are still processing the clip. It can be present while clip is still in transcoding state for videos
    if (!src) {
        return /*#__PURE__*/ _jsx(AssetGalleryCardProcessing, {
            ext: ext
        });
    }
    const imageClassNames = tailwindMerge("block min-h-full w-full rounded-4 object-cover", isLoaded ? "opacity-100" : "opacity-0", className);
    return animatedSrc ? /*#__PURE__*/ _jsx("img", {
        alt: description,
        src: animatedSrc,
        className: imageClassNames
    }) : /*#__PURE__*/ _jsx(ImgixImage, {
        alt: description || "",
        fallbackUrl: getCloudFrontUrlFromImgixUrl(src),
        src: src,
        imgixParams: {
            auto: "compress",
            fit: "crop",
            cs: "origin",
            ...imgixParams
        },
        width: imgixDimensions.width,
        height: imgixDimensions.height,
        onLoad: ()=>setLoaded(true),
        className: imageClassNames
    });
});
GalleryAssetThumbnailImage.displayName = "GalleryAssetThumbnailImage";
